import { kk } from './i18n/kk';
import { ru } from './i18n/ru';
import { TranslocoService } from '@jsverse/transloco';

export * from './product/info-select/product-info-select.component';
export * from './store-select/store-select.component';
export * from './tag-select/tag-select.component';
export * from './paged-list/paged-list.component';
export * from './user-select/user-select.component';
export * from './org-select/org-select.component';
export * from './city-select/city-select.component';
export * from './country-select/country-select.component';
export * from './label-edit/label-edit.component';
export * from './brand-select/brand-select.component';
export * from './product/category-select/product-category-select.component';
export * from './enum-select/enum-select.component';
export * from './unit-measure-select/unit-measure-select.component';
export * from './bank-select/bank-select.component';
export * from './group-select/group-select.component';
export * from './workflow-category-select/workflow-category-select.component';
export * from './dictionary-select/dictionary-select.component';

export function addI18n(tr: TranslocoService) {
  tr.setTranslation(kk, 'kk', {merge: true});
  tr.setTranslation(ru, 'ru', {merge: true});
}
